@if (CMSData) {
  <div [innerHTML]="displayText(footerBlock)"> </div>
}